import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {EntityAlert} from '../../../models/EntityAlert';
import {IOutput} from '../../../models/ISpec';
import {IBounds, IEntityAlert, IKeyValuePair, ILedInfo} from '../../../models/common';
import {ADD_OUTPUT, REMOVE_OUTPUT} from '../../../models/view';
import {isNullOrUndefined} from 'util';
import {SPEC_VALUE_OUTPUTS_INIT} from '../../../models/Spec_States';
import {MatDialog} from '@angular/material/dialog';
import {LedPreselectDialogComponent} from './led-preselect-dialog/led-preselect-dialog.component';
import {Router} from '@angular/router';
import {ResetSpecsService} from "../../reset-specs.service";
import {ApplicationSpecActions} from "../../../Redux/Actions/application-spec-actions";
import {ActionsService} from "../../../Redux/Actions/actions.service";
import {Utils} from "../../../common/utils";
import {Subscription} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import * as R from "ramda";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'edsng-v-output',
  templateUrl: './v-output.component.html',
  styleUrls: ['./v-output.component.css']
})
export class VOutputComponent implements OnDestroy, AfterViewInit {
  customLed = 'custom';

  showSpinnerLed: boolean = false;

  ledRowSelected: ILedInfo;

  @Input() minOutput: number = 0;

  private handles: Subscription[] = [];

  /**
   * Booleano se il component deve avere un addButton interno o meno
   */
  @Input() addButton: boolean = true;

  @Input() isLedComponent: boolean = false;
  @Input() isLedParallel: boolean = false;

  @Input() VoutSpec: IOutput<number>;
  @Input() OutValidation: IOutput<IEntityAlert>;
  @Output() outputChange: EventEmitter<IOutput<number>> = new EventEmitter<IOutput<number>>();

  @Input() outputsBound: IBounds;
  @Output() outputsResize: EventEmitter<IKeyValuePair> = new EventEmitter<IKeyValuePair>();
  @Output() openLedDlg: EventEmitter<any> = new EventEmitter();

  outputSpec: FormGroup;
  selectedLedComponent: ILedInfo;
  stringSelectedLed: string = '';

  private static outputBaseElem(voltage = null, current = null): FormGroup {
    return new FormGroup({
      voltage: new FormControl(voltage),
      current: new FormControl(current)
    });
  }

  constructor(public router: Router, public fb: FormBuilder, private dialog: MatDialog, private reset: ResetSpecsService, private act: ActionsService, private translate: TranslateService) {
    this.outputSpec = fb.group({
      outputsArr: fb.array([VOutputComponent.outputBaseElem()]),
      ledParam: fb.group({
        serial: [1],
        parallel: [1],
        rd: ['']
      })
    });

    this.handles.push(
      this.reset.onReset.subscribe(() => this.resetFilterOutput())
    );
  }

  get outputsCtrl(): FormArray {return this.outputSpec.get('outputsArr') as FormArray; }
  get ledRdParamCtrl(): FormControl {return this.outputSpec.get('ledParam.rd') as FormControl; }
  get ledSerialParamCtrl(): FormControl {return this.outputSpec.get('ledParam.serial') as FormControl; }
  get ledParallelParamCtrl(): FormControl {return this.outputSpec.get('ledParam.parallel') as FormControl; }

  ngAfterViewInit() {
    setTimeout(() => {
      this.outputsCtrl.controls[0].setValue({voltage: this.VoutSpec.outputs[0].voltage, current: this.VoutSpec.outputs[0].current});
      if (this.outputsCtrl.length < this.VoutSpec.outputs.length) {
        for (let i = 1; i < this.VoutSpec.outputs.length; i++) {//
          this.outputsCtrl.push(VOutputComponent.outputBaseElem());
          this.outputsCtrl.controls[i].setValue({voltage: this.VoutSpec.outputs[i].voltage, current: this.VoutSpec.outputs[i].current});
        }
      }
      if (this.isLedComponent || this.isLedParallel) {
        this.ledRdParamCtrl.setValue(this.VoutSpec.ledParam.rd);
        this.ledSerialParamCtrl.setValue(this.VoutSpec.ledParam.serial);
        if (this.isLedParallel) {
          this.ledParallelParamCtrl.setValue(this.VoutSpec.ledParam.parallel);
        }
      }
    }, 1);

    this.handles.push(
      this.outputSpec.valueChanges
        .pipe(distinctUntilChanged((prev, curr) => R.equals(prev, curr)), debounceTime(300))
        .subscribe(x => this.setAllOutput(x))
    );
  }

  ngOnDestroy() {
    this.handles.forEach(x => x.unsubscribe());
  }

  setAllOutput(x: any) {
    // globalOutput param is only read
    const _output: IOutput<number> = {
      outputs: x.outputsArr,
      globalOutput: SPEC_VALUE_OUTPUTS_INIT,
      ledParam: {
        serial: x.ledParam.serial,
        parallel: x.ledParam.parallel,
        rd: x.ledParam.rd,
        selectedLed: this.selectedLedComponent
      }
    };
    this.outputChange.emit(_output);
  }

  addOutput() {
    if (this.outputsCtrl.length < this.outputsBound.max) {
      this.outputsCtrl.push(VOutputComponent.outputBaseElem());
      this.outputsResize.emit(ADD_OUTPUT);
    }
  }

  removeOutputItem(idx) {
    if (this.outputsCtrl.length > this.outputsBound.min) {
      this.outputsCtrl.removeAt(idx);
      this.outputsResize.emit({
        key: REMOVE_OUTPUT.key,
        value: idx
      });
    }
  }

  getTypeName(i: IEntityAlert) {
    if (!isNullOrUndefined(i)) {
      return EntityAlert.getTypeName(i);
    }
    return '';
  }

  getMessage(i: IEntityAlert) {
    if (i) {
      return EntityAlert.getMessage(i, this.translate);
    }
    return '';
  }

  isParamExist(o: any) {
    return !isNullOrUndefined(o);
  }

  openLedsDlg() {
    // console.log("Start Preselect LED DIALOG");
    this.showSpinnerLed = !this.showSpinnerLed;
    const ledsDlg = LedPreselectDialogComponent.openDialog(
      this.dialog,
      this.ledRowSelected
    );
    this.handles.push(
    ledsDlg.componentInstance.selectedItem
      .subscribe((x: ILedInfo) => {
        // console.log("Exit Preselect LED DIALOG");
        this.showSpinnerLed = !this.showSpinnerLed;
        this.outputsCtrl.controls[0].setValue({ voltage: parseFloat(x.VF), current: parseFloat(x.IF) });
        this.ledRdParamCtrl.setValue(parseFloat(x.Rd));
        this.selectedLedComponent = x;
        this.ledRowSelected = x;
        this.customLed = 'led';
        this.stringSelectedLed = x.Manufacturer + ' ' + x.Family;
        this.act.sendAction(ApplicationSpecActions.setSelectedLed(x));
      })
    );
  }

  resetFilterOutput() {
    for (let i = 0; i < this.outputsCtrl.controls.length; i++) {
        this.outputsCtrl.controls[i].setValue({ voltage: null, current: null });
    }
    this.ledParallelParamCtrl.setValue(1);
    this.ledSerialParamCtrl.setValue(1);
    this.ledRdParamCtrl.setValue(null);
    this.outputSpec.get('ledParam.serial');

    this.act.sendAction(ApplicationSpecActions.setSelectedLed(null));
    this.selectedLedComponent = this.resetSelectedLed();
    this.ledRowSelected = undefined;
    this.customLed = 'custom';
    this.stringSelectedLed = '';
  }

  isNotANumber(n) {
    if (typeof n !== 'number') {
      return true;
    }
    return n !== n;
  }

  isValidNumber(n) {
    return  !this.isNotANumber(n) && Utils.isValueReal(n) && n > 0;
  }

  changeToCustom(value) {
    this.act.sendAction(ApplicationSpecActions.setSelectedLed(null));
    this.selectedLedComponent = this.resetSelectedLed();
    this.ledRowSelected = undefined;
    this.customLed = 'custom';
    this.stringSelectedLed = '';
  }

  resetSelectedLed() {
    return {
      Manufacturer: '',
      Family: '',
      PN: '',
      VF: '',
      VFMax: '',
      IF: '',
      Rd: '',
      Color: '',
      Flux: '',
      URL_Manufacturer: '',
      URL_PN: ''
    };
  }

  /**
   * Funzione richiamata all'onkeypress su LedInTheString e NumberOfString
   */
  onlyIntegers(evt) {
    return  (/[\d]/.test(evt.key));
  }
}
